<template>
  <form
    @submit.prevent="validateForm"
    class="subuser-form"
  >
    <div class="form-field">
      <label>Email</label>
      <div class="input-container">
        <input v-model="email" type="text" placeholder="Email" class="text-input" />
        <div
          v-if="errors.email.length"
          class="error"
        >
          {{ errors.email[0] }}
        </div>
      </div>
    </div>
    <div class="form-field">
      <label>Password</label>
      <div class="input-container">
        <input v-model="password" type="password" placeholder="Password" class="text-input" />
        <div
          v-if="errors.password.length"
          class="error"
        >
          {{ errors.password[0] }}
        </div>
      </div>
    </div>
    <div class="form-field">
      <label>Confirmación de Password</label>
      <div class="input-container">
        <input v-model="passwordConfirmation" type="password" placeholder="Confirmación de Password" class="text-input" />
        <div
          v-if="errors.passwordConfirmation.length"
          class="error"
        >
          {{ errors.passwordConfirmation[0] }}
        </div>
      </div>
    </div>
    <button
      v-if="!isLoading"
      :disabled="isButtonDisabled"
      class="btn"
    >
      {{ buttonLabel }}
    </button>
    <button v-else disabled class="btn">
      Cargando...
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-notch" class="loading-icon svg-inline--fa fa-circle-notch fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>
    </button>
    <ErrorModal
      @confirm="closeModal"
      :active="isErrorModalActive"
      :message="modalMessage"
    />
    <SuccessModal
      @confirm="closeModal"
      :active="isSuccessModalActive"
      :message="modalMessage"
    />
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ErrorModal from '@/components/ErrorModal'
import SuccessModal from '@/components/SuccessModal'

export default {
  name: 'SubuserForm',
  components: {
    ErrorModal,
    SuccessModal
  },
  props: {
    userType: {
      type: String,
      default: 'operator'
    }
  },
  data () {
    return {
      errors: {
        email: [],
        password: [],
        passwordConfirmation: []
      },
      email: '',
      isErrorModalActive: false,
      isLoading: false,
      isSuccessModalActive: false,
      modalMessage: '',
      password: '',
      passwordConfirmation: ''
    }
  },
  computed: {
    ...mapGetters('subusers', [
      'operator',
      'reporter'
    ]),
    buttonLabel () {
      return this.user ? 'Actualizar' : 'Crear'
    },
    isButtonDisabled () {
      const isUpdate = !!this.user

      return isUpdate && this.email === this.user.email && this.password.length < 1 && this.passwordConfirmation.length < 1
    },
    user () {
      return this[this.userType]
    }
  },
  watch: {
    user () {
      this.email = this.user.email
    }
  },
  methods: {
    ...mapActions('subusers', [
      'createSubuser',
      'updateSubuser'
    ]),
    cleanErrors () {
      this.errors = {
        email: [],
        password: [],
        passwordConfirmation: []
      }
    },
    closeModal () {
      this.isSuccessModalActive = false
      this.isErrorModalActive = false
    },
    async sendCreateData () {
      const data = {
        email: this.email,
        password: this.password,
        password_confirmation: this.paswordConfirmation,
        role: this.userType
      }

      const { error } = await this.createSubuser(data)

      this.isLoading = false

      if (error) {
        this.modalMessage = 'Lo sentimos, hubo un error al intentar crear un subusuario. Intenta de nuevo.'
        this.isErrorModalActive = true

        return
      }

      this.password = ''
      this.passwordConfirmation = ''
      this.modalMessage = 'Listo, se ha creado un nuevo subusuario.'
      this.isSuccessModalActive = true
    },
    async sendUpdateData () {
      const data = {}

      if (this.email !== this.user.email) { data.email = this.email }
      if (this.password.length > 0 && this.passwordConfirmation.length > 0) {
        data.password = this.password
        data.passwordConfirmation = this.passwordConfirmation
      }

      const { error } = await this.updateSubuser({ id: this.user.id, data })

      this.isLoading = false

      if (error) {
        this.modalMessage = 'Lo sentimos, hubo un error al intentar actualizar el subusuario. Intenta de nuevo.'
        this.isErrorModalActive = true

        return
      }

      this.password = ''
      this.passwordConfirmation = ''
      this.modalMessage = 'Listo, se ha actualizado el subusario.'
      this.isSuccessModalActive = true
    },
    validateForm () {
      const emailRegexp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
      const isUpdate = !!this.user

      this.cleanErrors()
      this.isLoading = true

      if (!emailRegexp.test(this.email)) {
        this.errors = { ...this.errors, email: ['El email debe tener un formato válido'] }
      }

      if ((!isUpdate && this.password.length < 6) || (isUpdate && (this.password.length > 0 && this.password.length < 6))) {
        this.errors = { ...this.errors, password: ['La contraseña debe ser mayor a 6 caracteres'] }
      }

      if ((!isUpdate && this.passwordConfirmation.length < 6) || (isUpdate && (this.passwordConfirmation.length > 0 && this.passwordConfirmation.length < 6))) {
        this.errors = { ...this.errors, passwordConfirmation: ['La contraseña debe ser mayor a 6 caracteres'] }
      }

      if ((!isUpdate && this.password !== this.passwordConfirmation) || (isUpdate && (this.password.length > 0 || this.passwordConfirmation.length > 0) && this.password !== this.passwordConfirmation)) {
        this.errors = {
          ...this.errors,
          password: [...this.errors.password, 'La contraseña ya la confirmación de contraseña deben coincidir'],
          passwordConfirmation: [...this.errors.passwordConfirmation, 'La contraseña y la confirmación de contraseña deben coincidir']
        }
      }

      if (!this.errors.email.length && !this.errors.password.length && !this.errors.passwordConfirmation.length) {
        isUpdate ? this.sendUpdateData() : this.sendCreateData()

        return
      }

      this.isLoading = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.subuser-form {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.form-field {
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  margin: 0.5rem 0;

  > label {
    flex: 0 1 15rem;
  }
}

.input-container {
  flex: 1 1 15rem;
}

.text-input {
  background-color: $light-grey;
  border-radius: 1rem;
  border-width: 0;
  box-sizing: border-box;
  padding: 0.5rem 0.5rem;
  width: 100%;

  &:focus {
    outline-width: 0;
  }
}

.btn {
  align-self: center;
  background-color: $light-blue;
  border-radius: 1rem;
  border: 0;
  color: white;
  cursor: pointer;
  display: flex;
  margin: 1rem 0;
  padding: 0.5rem 1.5rem;

  &:disabled {
    background-color: $light-blue-disabled;
    cursor: default;
  }
}

.loading-icon {
  animation-name: spin;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  margin-left: 0.25rem;
  width: 1rem;
}

.error {
  color: $red;
  font-size: 0.75rem;
  margin: 0.5rem;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
